import { render, staticRenderFns } from "./EducationalAttainment.vue?vue&type=template&id=687c5a4a&"
import script from "./EducationalAttainment.vue?vue&type=script&lang=js&"
export * from "./EducationalAttainment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports